import * as React from 'react';
import styled from 'styled-components';
import { JRCSkeletonLine } from './JRCSkeletonLine';

const Divider = styled.div<{ width?: string }>`
    width: ${(props) => props.width ?? '100%'};
    height: 2px;
    border-bottom: 1px solid ${(props) => props.theme.color.grey1};
`;

const SkeletonRowContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1 100%;
    overflow: hidden;
    margin: 8px 32px;
    padding: 22px;
    width: 100%;
`;

const SkeletonLines = styled.div`
    display: flex;
    flex: 4;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 2px 8px;
    width: 100%;
`;

export type SkeletonListProps = {
    margin?: string;
    width?: string;
};

export const JRCSkeletonList: React.FunctionComponent<SkeletonListProps> = ({ margin, width }) => (
    <SkeletonRowContainer>
        <SkeletonLines>
            {[...Array(10)].map((_, index) => {
                return (
                    <div key={`JRCSkeletonList-line-${index}`} style={{ width: '100%' }}>
                        <JRCSkeletonLine margin={margin ?? '1em'} width={width ?? '80%'} />
                        <Divider width={width ?? '80%'} />
                    </div>
                );
            })}
        </SkeletonLines>
    </SkeletonRowContainer>
);
